
import React from 'react';
import { Lock } from "lucide-react";

const PrivacyBanner = () => {
  return (
    <section className="py-6 px-4 sm:px-6 bg-green-50">
      <div className="max-w-2xl mx-auto text-center">
        <div className="flex items-center justify-center gap-3">
          <Lock className="h-5 w-5 text-green-600" />
          <p 
            className="text-base sm:text-lg font-medium text-gray-800"
            style={{ fontFamily: 'Inter, system-ui, sans-serif' }}
          >
            Tu privacidad es primero.
          </p>
        </div>
        <p 
          className="text-sm text-gray-600 mt-1"
          style={{ fontFamily: 'Inter, system-ui, sans-serif' }}
        >
          No compartimos tu información. Sin abogados. Sin juicios.
        </p>
      </div>
    </section>
  );
};

export default PrivacyBanner;
